import { icon } from '@fortawesome/fontawesome-svg-core';

import { propertyTypeIcon } from 'components/ui/property_type_icon';

import './map_pin.scss';

export const MAP_PIN_DETAIL_ZOOM = 11;
// How far above its point a pin's badge reaches, so an info window opens above the pin, not on it.
export const MAP_PIN_HEIGHT = 22;

// A map draws hundreds of pins over a handful of property types, so each type's markup is built once.
const htmlByType = new Map<number | null, string>();
const elementByType = new Map<number | null, HTMLDivElement>();

export function mapPinHtml(propertyTypeId: number | null | undefined): string {
  const key = propertyTypeId ?? null;
  let html = htmlByType.get(key);
  if (html == null) {
    const svg = icon(propertyTypeIcon(key)).html.join('');
    html = `<span class="map-pin__dot"></span><span class="map-pin__badge">${svg}</span>`;
    htmlByType.set(key, html);
  }
  return html;
}

export function mapPinElement(propertyTypeId: number | null | undefined): HTMLDivElement {
  const key = propertyTypeId ?? null;
  let template = elementByType.get(key);
  if (template == null) {
    template = document.createElement('div');
    template.className = 'map-pin';
    template.innerHTML = mapPinHtml(key);
    elementByType.set(key, template);
  }
  return template.cloneNode(true) as HTMLDivElement;
}
